import { HttpService } from 'services/http';

export const getAllTransactionsAPI = (queryParams) => HttpService.get('/v3/transactions', queryParams);

export const getTransactionIdDetails = (transactionId) => HttpService.get(`/v3/transactions/${transactionId}`);

export const createNewPaymentAPI = (requestPayload) => HttpService.post('/v3/payments/create', requestPayload);
